import React from 'react';
import { IonCol, IonInput, IonButton, IonGrid, IonRow } from '@ionic/react';

// Components
import { ValidatorMessageComponent } from '../../components';

// Validators
import { AppValidator } from '../../validators';

// Helpers
import { hasAccess } from '../../helpers';

export const DocumentComponent = ({
    document,
    handleContinue,
    handleInputChange,
    inputs,
    validation,
    pageConfig,
    userPermission
}) => {

    const hasPermissions = hasAccess(userPermission, pageConfig.permissions);
    const mainteinment = AppValidator.AppIsMainteinment();

    return (
        <form onSubmit={handleContinue} noValidate>
            <IonGrid>
                <IonRow class="grid-rows-3">
                    <IonCol>
                        <p className="subtitle">Ingresá el documento del socio para poder realizar las validaciones correspondientes</p>
                    </IonCol>
                    <IonCol>
                        <IonRow className="justCenter">
                            <div className="price">
                                <IonInput
                                    name='document'
                                    type="number"
                                    value={document}
                                    placeholder="DNI"
                                    onIonChange={handleInputChange}
                                    required={pageConfig.rules.inputs[inputs.document].required.value}
                                    min={pageConfig.rules.inputs[inputs.document].min.value}
                                    max={pageConfig.rules.inputs[inputs.document].max.value}
                                >
                                </IonInput>
                            </div>
                            {
                                validation.summary?.map((v, index) => {

                                    return v.key === inputs.document &&
                                        <ValidatorMessageComponent key={index} message={v.message} />
                                })
                            }
                        </IonRow>
                    </IonCol>
                    <IonCol className="dispFlex-justCenter">
                        <IonButton
                            type="submit"
                            shape="round"
                            size="undefined"
                            disabled={!validation.formComplete || !validation.formValid || !hasPermissions || mainteinment.enabled}
                        >
                            CONTINUAR
                        </IonButton>
                    </IonCol>
                </IonRow>
            </IonGrid>
        </form>
    )
}
